<script>
  import { onMount } from 'svelte';
  import { select } from 'd3-selection';
  import { scaleLinear } from 'd3-scale';
  export let data = {};
  export let chartProps = {
    height: 0,
    margins: {
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
    },
    width: 0,
  };
  export let maxVal = null;
  let el;

  const draw = () => {
    const elems = data.meloni.length - 1;
    const maxX = maxVal ? maxVal : Math.max(...new Set(data.meloni.map(d => d.count)), ...new Set(data.schlein.map(d => d.count)));
    const xScale = scaleLinear()
      .range([chartProps.seriesSize, 0])
      .domain([0, maxX]);

    const container = select(el);
    container.html('');
    const svg = container.append('svg')
      .attr('width', chartProps.width)
      .attr('height', chartProps.height)
      .attr('viewbox', `0 0 ${chartProps.width} ${chartProps.height}`);
    // Headers
    const gh = svg.append('g')
      .attr('transform', `translate(${chartProps.margins.left}, 0)`);
    gh.append('text')
      .attr('x', Math.floor(chartProps.seriesSize / 2))
      .attr('y', Math.floor(chartProps.margins.top / 2))
      .attr('class', 'chart--header')
      .style('text-anchor', 'middle')
      .style('dominant-baseline', 'middle')
      .style('fill', 'var(--meloni)')
      .text('Giorgia Meloni');
    gh.append('text')
      .attr('x', Math.floor(chartProps.seriesSize * 1.5 + chartProps.axisSize))
      .attr('y', Math.floor(chartProps.margins.top / 2))
      .attr('class', 'chart--header')
      .style('text-anchor', 'middle')
      .style('dominant-baseline', 'middle')
      .style('fill', 'var(--schlein)')
      .text('Elly Schlein');
    
    // Axis
    const ga = svg.append('g')
      .attr('transform', `translate(${chartProps.margins.left + chartProps.seriesSize}, ${(chartProps.margins.top)})`);
    const fixedAxisX = Math.floor(chartProps.axisSize / 2);
    // Meloni
    const gm = svg.append('g')
      .attr('transform', `translate(${chartProps.margins.right}, ${chartProps.margins.top})`);
    // Schlein
    const gs = svg.append('g')
      .attr('transform', `translate(${chartProps.margins.left + chartProps.axisSize + chartProps.seriesSize}, ${chartProps.margins.top})`);
    
    data.meloni.forEach((d, i) => {
      const thisDay = new Date(d.published_at);
      const x = xScale(thisDay);
      // Axis
      let format = { day: '2-digit', month: '2-digit' };
      if (i === 0 || thisDay.getMonth() === 0) {
        format = { dateStyle: 'short' };
      }
      if (i === 0 || (i % 2 === 0) || (i === elems && thisDay.getDate() > 10) || thisDay.getDate() === 1) {
        ga.append('line')
          .attr('class', 'axis--thick')
          .style('stroke-width', 1)
          .style('stroke', 'var(--dark)')
          .attr('x1', 0)
          .attr('x2', 8)
          .attr('y1', chartProps.lineSize * i)
          .attr('y2', chartProps.lineSize * i);

        ga.append('line')
          .attr('class', 'axis--thick')
          .style('stroke-width', 1)
          .style('stroke', 'var(--dark)')
          .attr('x1', chartProps.axisSize)
          .attr('x2', chartProps.axisSize - 8)
          .attr('y1', chartProps.lineSize * i)
          .attr('y2', chartProps.lineSize * i);

        ga.append('text')
          .attr('x', fixedAxisX)
          .attr('y', chartProps.lineSize * i)
          .attr('text-anchor', 'middle')
          .attr('dominant-baseline', 'hanging')
          .attr('class', 'axis--label')
          .text(new Intl.DateTimeFormat('it-IT', format).format(thisDay))
      }
      // Bars
      gm.append('rect')
        .attr('x', xScale(d.count))
        .attr('y', chartProps.lineSize * i)
        .attr('width', d.count === 0 ? 1 : chartProps.seriesSize - xScale(d.count))
        .attr('height', chartProps.barSize)
        .attr('class', 'bar--meloni')
        .style('fill', d.count === 0 ? 'var(--light)' : 'var(--meloni')
        .style('stroke', 'none');
    });

    data.schlein.forEach((d, i) => {
      const thisDay = new Date(d.published_at);
      // Bars
      gs.append('rect')
        .attr('x', 0)
        .attr('y', chartProps.lineSize * i)
        .attr('width',  d.count === 0 ? 1 : chartProps.seriesSize - xScale(d.count))
        .attr('height', chartProps.barSize)
        .attr('class', 'bar--schlein')
        .style('fill', d.count === 0 ? 'var(--light)' : 'var(--schlein')
        .style('stroke', 'none');
    });

    // Annotations
    gm.append('line')
      .attr('x1', xScale(maxX))
      .attr('x2', xScale(maxX))
      .attr('y1', 0)
      .attr('y2', chartProps.lineSize * elems)
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gm.append('text')
      .attr('x', xScale(maxX))
      .attr('y', 0)
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'start')
      .style('fill', 'var(--notsodark)')
      .text(`${maxX} news`);
    gm.append('line')
      .attr('x1', xScale(Math.floor(maxX / 3)))
      .attr('x2', xScale(Math.floor(maxX / 3)))
      .attr('y1', 0)
      .attr('y2', chartProps.lineSize * elems)
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gm.append('text')
      .attr('x', xScale(Math.floor(maxX / 3)))
      .attr('y', 0)
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'middle')
      .style('fill', 'var(--notsodark)')
      .text(`${Math.floor(maxX / 3)}`);
    gm.append('line')
      .attr('x1', xScale(Math.floor(maxX / 3 * 2)))
      .attr('x2', xScale(Math.floor(maxX / 3 * 2)))
      .attr('y1', 0)
      .attr('y2', chartProps.lineSize * elems)
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gm.append('text')
      .attr('x', xScale(Math.floor(maxX / 3 * 2)))
      .attr('y', 0)
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'middle')
      .style('fill', 'var(--notsodark)')
      .text(`${Math.floor(maxX / 3 * 2)}`);
    gm.append('text')
      .attr('x', xScale(0))
      .attr('y', 0)
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'end')
      .style('fill', 'var(--notsodark)')
      .text(0);
      
    gs.append('line')
      .attr('x1', chartProps.seriesSize - xScale(maxX))
      .attr('x2', chartProps.seriesSize - xScale(maxX))
      .attr('y1', 0)
      .attr('y2', chartProps.lineSize * elems)
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gs.append('text')
      .attr('x', chartProps.seriesSize - xScale(maxX))
      .attr('y', 0)
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'end')
      .style('fill', 'var(--notsodark)')
      .text(`${maxX} news`);
    gs.append('line')
      .attr('x1', chartProps.seriesSize - xScale(Math.floor(maxX / 3)))
      .attr('x2', chartProps.seriesSize - xScale(Math.floor(maxX / 3)))
      .attr('y1', 0)
      .attr('y2', chartProps.lineSize * elems)
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gs.append('text')
      .attr('x', chartProps.seriesSize - xScale(Math.floor(maxX / 3)))
      .attr('y', 0)
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'middle')
      .style('fill', 'var(--notsodark)')
      .text(`${Math.floor(maxX / 3)}`);
    gs.append('line')
      .attr('x1', chartProps.seriesSize - xScale(Math.floor(maxX / 3 * 2)))
      .attr('x2', chartProps.seriesSize - xScale(Math.floor(maxX / 3 * 2)))
      .attr('y1', 0)
      .attr('y2', chartProps.lineSize * elems)
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gs.append('text')
      .attr('x', chartProps.seriesSize - xScale(Math.floor(maxX / 3 * 2)))
      .attr('y', 0)
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'middle')
      .style('fill', 'var(--notsodark)')
      .text(`${Math.floor(maxX / 3 * 2)}`);
    gs.append('text')
      .attr('x', 0)
      .attr('y', 0)
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'start')
      .style('fill', 'var(--notsodark)')
      .text(0);   
  };

  $: if (chartProps.width > 0 && chartProps.height > 0) {
     draw();
  };

  onMount(() => draw());
</script>

<div class="chartVertical" bind:this={el} />

<style>
</style>